import { validationTypes } from "../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/forms/libs/data/formFieldType";

const initState = {
  category: "",
  xmlTemplateId: "",
  origin: ``
};

export const addEditMappingSchemaFieldconfig = {
  name: "Report Type Details",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Basic User Details",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row row-gap"></div>,
      fields: [
        {
          id: "origin",
          label: "Origin",
          Field_Name: "Origin",
          fieldType: FormFieldTypes.SELECT,
          dataField: "origin",
          fieldSetting: {
            placeholder: "Please select Origin",
            allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        },

        {
          id: "category",
          label: "Category",
          Field_Name: "Category",
          fieldType: FormFieldTypes.SELECT,
          dataField: "category",
          fieldSetting: {
            placeholder: "Please select Category",
            allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        },

        {
          id: "xmlTemplateId",
          label: "Map Field Value",
          Field_Name: "xmlTemplateId",
          fieldType: FormFieldTypes.SELECT,
          dataField: "xmlTemplateId",
          validation: [{ type: validationTypes.REQUIRE }],
          fieldSetting: {
            placeholder: "Please select Field",
            allowSpace: true,
            isDisable: false,
            options: [],
          },
          style: {
            containerCss: "col-lg-12 col-md-12 col-12",
          },
        },
      ],
    },
  ],
};
